import script from "./AddToCustomDashboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToCustomDashboardModal.vue?vue&type=script&setup=true&lang=js"

import "./AddToCustomDashboardModal.vue?vue&type=style&index=0&id=e17e70b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e17e70b2"]])

export default __exports__